const ONBOARDING_BASE_ROUTE = '/onboarding';

export const ONBOARDING_API_ROUTES = {
  baseRoute: () => ONBOARDING_BASE_ROUTE,
  attributes: () => `${ONBOARDING_BASE_ROUTE}/attributes`,
  flags: () => `${ONBOARDING_BASE_ROUTE}/flags`,
} as const;
